import React from "react";
import "./MayaBrandMark.css";

/**
 * My Eats logo for headers and auth screens.
 * @param {"header"|"login"|"auth"} [variant="header"]
 * @param {string} [tagline] unused — kept for existing call sites
 */
const MayaBrandMark = ({ variant = "header", className = "" }) => {
  return (
    <div
      className={`maya-brand maya-brand--${variant} ${className}`.trim()}
      aria-label="My Eats"
    >
      <img
        src={`${process.env.PUBLIC_URL || ""}/myeats-logo.png`}
        alt="My Eats"
        className="maya-brand__logo"
      />
    </div>
  );
};

export default MayaBrandMark;
